package presentation.screens.otp

import utils.UiAction
import utils.UiState

data class OtpState(
    val isLoading: Boolean = false,
    val isError: Boolean = false,
    val remainingTime: Int,
    val flowType: OtpFlowType = OtpFlowType.Verification,
    val otp: List<String>,
) : UiState {

    enum class OtpFlowType {
        Verification,
        Password
    }

    companion object {
        val initOtp =  listOf("", "", "", "", "", "")
    }
}

sealed interface OtpMVIAction : UiAction {

    data object ResendOtp : OtpMVIAction
    data object BackClicked : OtpMVIAction
    data class OtpChanged(val index: Int, val value: String) : OtpMVIAction
}
